import { render } from "./WorkflowDropdown.vue?vue&type=template&id=12063b07&scoped=true"
import script from "./WorkflowDropdown.vue?vue&type=script&lang=js"
export * from "./WorkflowDropdown.vue?vue&type=script&lang=js"

import "./WorkflowDropdown.vue?vue&type=style&index=0&id=12063b07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12063b07"]])

export default __exports__